import { createApp } from 'vue'
import { createPinia } from 'pinia'
import {
  appRunUuidStorage,
  httpLogPlugin,
  logService,
  prefixLogPlugin
} from '@nsftx/seven-client-retail-utils'
import { createSevenIgamingPlatformPlugin } from '@nsftx/seven-client-retail-vue-sgp'
import { vueDmCoreConfigPlugin } from '@nsftx/seven-client-retail-vue-dm-core'
import { useDeviceManagementStore } from '@nsftx/seven-client-retail-vue-dm'
import { createRetailSdkPlugin } from '@nsftx/seven-nxg-retail-vue-sdk'
import translationsPlugin from './plugins/translationsPlugin'

import App from './App.vue'
import router from './router'
import { registerGuards } from '@/router/guards'
import '@/styles/main.scss'

const urlParams = new URLSearchParams(window.location.search)
const urlLogLevel = urlParams.get('logLevel')
const urlAppRunUuid = urlParams.get('appRunUuid')
const lsLogLevel = localStorage.getItem('sbo.logLevel')

if (urlAppRunUuid) {
  appRunUuidStorage.setAppRunUuid(urlAppRunUuid)
}

if (import.meta.env.PROD) {
  logService.setLogLevel(urlLogLevel?.toUpperCase() || lsLogLevel?.toUpperCase() || 'INFO')
  logService.registerPlugin(httpLogPlugin.apply, {
    apiUrl: import.meta.env.VITE_GRAPE_API_URL,
    user: import.meta.env.VITE_GRAPE_API_AUTH_USER,
    pass: import.meta.env.VITE_GRAPE_API_AUTH_PASS,
    appName: 'SSBT Back Office',
    channel: 'SSBT'
  })
}

logService.registerPlugin(prefixLogPlugin.apply)

const app = createApp(App)

app.use(createPinia())
app.use(createRetailSdkPlugin({ channel: 'sbo' }))
app.use(router)
app.use(translationsPlugin)
app.use(vueDmCoreConfigPlugin, {
  appName: 'ssbt-bo',
  getTenantUuid: () => useDeviceManagementStore().appData?.betshop.companyUuid ?? '',
  getDeviceUuid: () => useDeviceManagementStore().appData?.device.uuid ?? ''
})
app.use(createSevenIgamingPlatformPlugin, {
  token: null
})

registerGuards()

app.mount('#app')
